import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label?: string = '';
  @Input() disabled: boolean = false;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color: 'primary' | 'success' | 'warning' | 'danger' = 'primary';
  @Input() indeterminate: boolean = false;
  @Input() binary: boolean = true;
  @Input() id: string = `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  @Input() reverse: boolean = false;


  @Output() onChange = new EventEmitter<boolean>();

  value: boolean = false;

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  writeValue(value: any): void {
    this.value = !!value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.checked;
    this.onChangeCallback(this.value);
    this.onChange.emit(this.value);
    this.onTouchedCallback();
  }

  onLabelClick(): void {
    if (!this.disabled) {
      this.value = !this.value;
      this.onChangeCallback(this.value);
      this.onChange.emit(this.value);
      this.onTouchedCallback();
    }
  }
}
